/**
 * @generated SignedSource<<e3014e926f39f918c85f148be5663d63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserStatus = "active" | "activeEfnNeeded" | "changeInProgress" | "doccheck" | "doctorWithEfnInitialValidation" | "efnNeeded" | "inactive" | "initialValidation" | "noProcess" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NavigateDirectToQuestionsAdvanceContentButton_UserFragment$data = {
  readonly extension: {
    readonly globalUserStatus?: UserStatus;
  } | null;
  readonly " $fragmentType": "NavigateDirectToQuestionsAdvanceContentButton_UserFragment";
};
export type NavigateDirectToQuestionsAdvanceContentButton_UserFragment$key = {
  readonly " $data"?: NavigateDirectToQuestionsAdvanceContentButton_UserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigateDirectToQuestionsAdvanceContentButton_UserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavigateDirectToQuestionsAdvanceContentButton_UserFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "userExtensionKind",
          "value": "InfectopharmUserExtension"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "globalUserStatus",
              "storageKey": null
            }
          ],
          "type": "InfectopharmUserExtension",
          "abstractKey": null
        }
      ],
      "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "341d0e1127988c7efbd490fef1690608";

export default node;
